"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const get_1 = __importDefault(require("lodash/get"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const filter_1 = __importDefault(require("../filterBlock/filter"));
const expertView_1 = __importDefault(require("../expertView/expertView"));
const searchbar_1 = __importDefault(require("../searchbar/searchbar"));
const linkBar_1 = __importDefault(require("../linkBar/linkBar"));
const pagination_1 = __importDefault(require("../../../../shared/components/pagination/pagination"));
const noResult_1 = __importDefault(require("../expertView/noResult"));
const svgIcons_1 = require("../../../../svgIcons");
const common_1 = require("../../../../utils/common");
const api_1 = require("../../../../services/api");
require("./directorySearch.scss");
const ajaxLoader_1 = __importDefault(require("../../../../shared/components/ajaxLoader/ajaxLoader"));
const noResult_2 = __importDefault(require("../../../../shared/components/noSearchResult/noResult"));
const DirectoryTypes = {
    "serviceExperts": {
        title: "Services",
        header: "Services",
        getter: "getServiceExperts",
        sidebar: "services"
    },
    "experts": {
        title: "Experts",
        header: "Areas of Expertise",
        getter: "getExperts",
        sidebar: "areas"
    }
};
function mutateFilter() {
    const mainPageWrapper = document.getElementById("main-page-wrapper");
    const dirSearchWrapper = document.getElementById('dir-search-bar-wrapper');
    const rootWrapper = document.getElementById('root');
    if (dirSearchWrapper && mainPageWrapper) {
        rootWrapper.insertBefore(dirSearchWrapper, mainPageWrapper);
        if (common_1.ifMobile()) {
            // dirSearchWrapper.style.position = 'absolute' maybe this will failed keeping for checking.
            dirSearchWrapper.style.zIndex = '749';
        }
        const calculate = () => {
            const top = window.scrollY;
            const elem = document.getElementById('directory-search-field');
            const isFocused = (document.activeElement === elem);
            if (isFocused && top > 0) {
                dirSearchWrapper.style.top = '0px';
            }
            else {
                dirSearchWrapper.style.top = '50px';
            }
        };
        document.addEventListener('scroll', (e) => {
            calculate();
        });
        dirSearchWrapper.addEventListener('click', () => {
            calculate();
        });
    }
}
function removeMutatedFilter() {
    const container = document.getElementById('experts-container');
    const dirSearchWrapper = document.getElementById('dir-search-bar-wrapper');
    if (dirSearchWrapper && container) {
        dirSearchWrapper.style.position = null;
        dirSearchWrapper.style.zIndex = null;
        container.appendChild(dirSearchWrapper);
    }
    else if (dirSearchWrapper) {
        dirSearchWrapper.remove();
    }
    document.removeEventListener('scroll', () => void (1), false);
    dirSearchWrapper.removeEventListener('click', () => void (1), false);
}
function fixIOSHeight() {
    const pageWrapper = document.getElementById("page_wrapper");
    const mobileFooterHeight = 88;
    const calcHeight = (pageWrapper.offsetHeight - mobileFooterHeight);
    pageWrapper.style.height = `${calcHeight}px`;
}
function removeFixedHeight() {
    const pageWrapper = document.getElementById("page_wrapper");
    pageWrapper.style.height = null;
}
class DirectorySearch extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.directoryType = "experts";
        this.state = {
            triggered: false,
            expanded: [],
            showIcon: true,
        };
        this.changeDirectoryFilterPosition = () => {
            const tmpFilterWrapper = document.createElement("div");
            tmpFilterWrapper.classList.add("experts-content");
            tmpFilterWrapper.id = `${this.directoryType}-tmp-filter-wrapper`;
            const filterContent = document.getElementById("experts-filter-block");
            tmpFilterWrapper.appendChild(filterContent);
            const mainPageWrapper = document.getElementById("main-page-wrapper");
            const rootWrapper = document.getElementById('root');
            rootWrapper.insertBefore(tmpFilterWrapper, mainPageWrapper);
        };
        this.putBackDirectoryFilter = () => {
            const filterContent = document.getElementById("experts-filter-block");
            const directorySearchBlock = document.getElementById("directory-search-block-wrapper");
            directorySearchBlock.appendChild(filterContent);
            const tmpFilterWrapper = document.getElementById(`${this.directoryType}-tmp-filter-wrapper`);
            tmpFilterWrapper === null || tmpFilterWrapper === void 0 ? void 0 : tmpFilterWrapper.remove();
        };
        this.clearFilter = () => {
            const { getServiceExperts, getExperts } = this.props;
            const requestType = this.directoryType === 'experts' ? getExperts : getServiceExperts;
            requestType(Object.assign(Object.assign({}, this.props.experts.filter), { selectedFilters: [], selectedStates: [], q: '' }));
        };
        this.triggerFilter = () => {
            const { triggered } = this.state;
            if (common_1.isMobileBrowser() || common_1.ifMobile()) {
                if (!triggered === true) {
                    this.changeDirectoryFilterPosition();
                }
                else if (!triggered === false) {
                    this.putBackDirectoryFilter();
                }
            }
            this.setState({ triggered: !triggered });
            this.setState({ expanded: [] });
        };
        this.handleExpanded = (node, nodeExpanded) => {
            const { expanded } = this.state;
            if (nodeExpanded) {
                this.setState({ expanded: nodeExpanded });
            }
            if (common_1.ifMobile() || common_1.isMobileBrowser().check) {
                const elem = node.target;
                setTimeout(() => {
                    const parent = elem.closest("li");
                    if (parent) {
                        document
                            .getElementsByClassName("mobile-scrollable")[0]
                            .scrollTo(0, parent.offsetTop - 10);
                    }
                }, 300);
            }
        };
        this.handleInputSearch = (value) => {
            this.setState({ showIcon: value });
        };
    }
    init() {
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual_1.default(this.props.experts.filter, prevProps.experts.filter)) {
            localStorage.removeItem('prevPath');
        }
    }
    componentDidMount() {
        this.init();
        if (common_1.ifMobile() || common_1.isMobileBrowser().check) {
            window.AppearMe.Widgets.Events.subscribe('onDirectoryBackAction', (e) => {
                var _a;
                //ReactDOM.unmountComponentAtNode(document.getElementById(`${this.directoryType}-tmp-filter-wrapper`));
                (_a = document.getElementById(`${this.directoryType}-tmp-filter-wrapper`)) === null || _a === void 0 ? void 0 : _a.remove();
            });
            mutateFilter();
        }
        window.AppearMe.Widgets.Events.subscribe('onDirectoryEnterAction', (e) => {
            localStorage.setItem('prevPath', e.detail.prevPath);
        });
    }
    componentWillUnmount() {
        if (common_1.ifMobile() || common_1.isMobileBrowser().check) {
            removeMutatedFilter();
        }
        removeFixedHeight();
        api_1.Experts.cancelAllRequest();
        this.props.resetMounted();
        if (document.location.href.indexOf("directory") === -1) {
            localStorage.removeItem("service_filter");
            localStorage.removeItem("expert_filter");
        }
        this.clearFilter();
    }
    render() {
        const requestFunction = this.directoryType === 'experts' ? this.props.getExperts : this.props.getServiceExperts;
        const { experts: { locations, expertsList, expertsCount, filter } } = this.props;
        const { triggered, showIcon } = this.state;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 12, id: 'dir-search-bar-wrapper' },
                react_1.default.createElement("div", { className: "tab-titles" }, DirectoryTypes[this.directoryType].title),
                react_1.default.createElement(core_1.Grid, { className: 'search-bar-block' },
                    react_1.default.createElement(searchbar_1.default, { directoryType: this.directoryType, handleInputChange: this.handleInputSearch })),
                react_1.default.createElement(core_1.Hidden, { mdUp: true },
                    react_1.default.createElement("div", { className: "mobile-switch", onClick: this.triggerFilter },
                        react_1.default.createElement(svgIcons_1.ExpandIcon, null),
                        react_1.default.createElement("span", null, "Filter")))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 12, className: "experts-content" },
                react_1.default.createElement(core_1.Grid, { className: "link-grid" },
                    react_1.default.createElement(linkBar_1.default, { directoryType: 'experts' }),
                    react_1.default.createElement(linkBar_1.default, { directoryType: 'services' })),
                react_1.default.createElement(core_1.Grid, { container: true, className: "d-flex justify-content-between" },
                    react_1.default.createElement(core_1.Grid, { item: true, md: 2, xs: 12, className: 'filter-grid-wrapper', id: 'directory-search-block-wrapper' },
                        react_1.default.createElement(core_1.Grid, { item: true, id: 'experts-filter-block', xs: 12, md: 2, className: `filter-grid mb-20 ${triggered ? 'filter-grid-mobile' : ''}` },
                            react_1.default.createElement("div", { className: "grid-info" },
                                react_1.default.createElement("div", { className: "grid-info-head" },
                                    react_1.default.createElement("span", { className: "grid-info-title" }, "Filter"),
                                    react_1.default.createElement(core_1.Box, { display: "flex", alignItems: "center" },
                                        react_1.default.createElement("a", { onClick: this.clearFilter, className: "clear-btn" }, "Clear")))),
                            react_1.default.createElement("div", { className: "mb-10 mb-md-0 mobile-scrollable" },
                                react_1.default.createElement("div", { className: "filter-blocks", id: "filter-block-areas" },
                                    react_1.default.createElement(filter_1.default, { directoryType: this.directoryType, filterList: get_1.default(this.props.experts, DirectoryTypes[this.directoryType].sidebar), header: DirectoryTypes[this.directoryType].header, type: 'selectedFilters', handleExpanded: this.handleExpanded, expanded: this.state.expanded })),
                                react_1.default.createElement("div", { className: "filter-blocks", id: "filter-block-locations" },
                                    react_1.default.createElement(filter_1.default, { directoryType: this.directoryType, filterList: locations, header: 'Location', type: 'selectedStates', handleExpanded: this.handleExpanded, expanded: this.state.expanded }))),
                            react_1.default.createElement(core_1.Hidden, { mdUp: true },
                                react_1.default.createElement("div", { className: "filter-btns-wrapper" },
                                    react_1.default.createElement(core_1.Button, { onClick: this.triggerFilter, variant: "contained", color: "primary", disableRipple: true, className: "v2-btn v2-btn-primary" }, "Save"),
                                    react_1.default.createElement(core_1.Button, { onClick: () => {
                                            this.clearFilter();
                                            this.triggerFilter();
                                        }, disableRipple: true, variant: "contained", className: "v2-btn v2-btn-tertiary" }, "Skip"))))),
                    expertsList.length > 0 &&
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 8 },
                            react_1.default.createElement("div", { className: 'experts-grid' },
                                react_1.default.createElement(ajaxLoader_1.default, null),
                                react_1.default.createElement(expertView_1.default, { directoryType: this.directoryType, expertList: expertsList, filterList: get_1.default(this.props.experts, DirectoryTypes[this.directoryType].sidebar) })),
                            expertsCount > filter.limit ?
                                react_1.default.createElement(pagination_1.default, { changeRequest: requestFunction, itemsCount: parseInt(expertsCount), resetConditions: [filter.selectedFilters, filter.selectedStates, filter.q], changeParams: filter, removeMutatedBlock: () => {
                                        if (document.getElementById(`${this.directoryType}-tmp-filter-wrapper`)) {
                                            this.putBackDirectoryFilter();
                                            this.triggerFilter();
                                        }
                                    }, browserHistoryHandle: () => requestFunction(Object.assign(Object.assign({}, this.props.experts.filter), { q: '', offset: parseInt(common_1.urlPrams("page")) - 1 || 0 })) }) :
                                null),
                    !expertsList.length && react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 8, className: 'vh-100' },
                        react_1.default.createElement(ajaxLoader_1.default, null),
                        this.props.experts.mounted && showIcon && react_1.default.createElement(noResult_1.default, { className: 'no-result-directory' }),
                        this.props.experts.mounted && !showIcon && react_1.default.createElement(noResult_2.default, null))))));
    }
}
exports.default = DirectorySearch;
